import { Loader2 } from 'lucide-react'
import { useUser } from '@/shared/hooks/useUser'
import { useTelegram } from '@/shared/hooks/useTelegram'
import AddResourceView from './AddResourceView'

export default function AddResource() {
  const { telegramId } = useTelegram()
  const { data: user, isLoading, error } = useUser(telegramId)

  if (isLoading) {
    return (
      <div className="fixed inset-0 bg-tg-bg z-[200] flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-tg-button" />
      </div>
    )
  }

  if (error || !user) {
    return (
      <div className="fixed inset-0 bg-tg-bg z-[200] flex items-center justify-center p-4">
        <div className="text-center">
          <div className="text-4xl mb-4">⚠️</div>
          <h2 className="text-lg font-semibold text-tg-text mb-2">Ошибка</h2>
          <p className="text-sm text-tg-hint">
            {error?.message || 'Не удалось загрузить данные пользователя'}
          </p>
        </div>
      </div>
    )
  }

  return <AddResourceView ownerId={user.id} />
}
